import { render, staticRenderFns } from "./PageHabitsTracker.vue?vue&type=template&id=0d085a0a"
import script from "./PageHabitsTracker.vue?vue&type=script&lang=js"
export * from "./PageHabitsTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports